import { Calendar, RefreshCcw } from 'lucide-react';

const fmt = (a) => '$' + (a || 0).toLocaleString('en-US', { minimumFractionDigits: 2 });

export function UpcomingRenewals({ renewals }) {
  if (!renewals || renewals.length === 0) return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="font-bold text-[#0A1628] flex items-center gap-2 mb-4"><RefreshCcw className="w-4 h-4 text-[#014DB7]" /> Upcoming Renewals</h3>
      <p className="text-sm text-gray-400 text-center py-6">No upcoming renewals</p>
    </div>
  );

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="font-bold text-[#0A1628] flex items-center gap-2 mb-4"><RefreshCcw className="w-4 h-4 text-[#014DB7]" /> Upcoming Renewals</h3>
      <div className="space-y-0 divide-y">
        {renewals.map((r, i) => <RenewalRow key={i} renewal={r} />)}
      </div>
    </div>
  );
}

function RenewalRow({ renewal }) {
  const d = new Date(renewal.next_billing_date);
  const now = new Date();
  const daysUntil = Math.ceil((d - now) / (1000 * 60 * 60 * 24));
  const isUrgent = daysUntil <= 7;
  const isSoon = daysUntil <= 30;

  return (
    <div className="flex items-center gap-3 py-3">
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${isUrgent ? 'bg-red-50' : isSoon ? 'bg-amber-50' : 'bg-blue-50'}`}>
        <Calendar className={`w-4 h-4 ${isUrgent ? 'text-red-500' : isSoon ? 'text-amber-500' : 'text-[#014DB7]'}`} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-[#0A1628] truncate">{renewal.client_name}</p>
        <p className="text-xs text-gray-500 truncate">{renewal.item}</p>
      </div>
      <div className="text-right flex-shrink-0">
        <p className="font-semibold text-sm text-[#0A1628]">{fmt(renewal.amount)}</p>
        <p className={`text-xs font-medium ${isUrgent ? 'text-red-500' : isSoon ? 'text-amber-500' : 'text-gray-400'}`}>
          {daysUntil <= 0 ? 'Due today' : daysUntil === 1 ? 'Tomorrow' : `${daysUntil} days`}
        </p>
      </div>
    </div>
  );
}
